var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 23,
    viewBox: "0 0 15 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50138 22.5C1.22928 17.355 -0.701498 7.05838 1.50546 6.12189C1.60575 6.07945 1.71506 6.05174 1.81637 6.01097L10.2053 2.62887M12.3889 3.7316L12.9403 6.19783L14.5 12.5M2.3494 7.08899C1.4009 8.81475 2.87493 16.091 4.06486 20.8741C4.32368 21.9168 5.49849 22.4634 6.51915 22.0348L8.5 21.2233M4.02084 7.193C4.4056 6.74061 4.80324 5.14338 3.91003 4.3268C3.75616 4.18448 3.56225 4.06619 3.32232 3.98162C1.70258 3.40939 0.669324 5.35347 1.64355 6.02246M3.88499 4.2557C4.02303 3.37908 5.20071 2.46354 6.62045 3.22372C8.14597 4.26558 7.37955 5.79769 6.68396 6.33221M6.68481 3.1484C6.9742 2.45734 8.06555 1.12477 9.50535 1.67254C11.439 2.69178 10.3259 4.69968 9.51659 4.95669M9.48894 1.57714C9.92859 0.80955 11.0255 0.0676472 12.0967 0.801457C13.168 1.53543 12.8282 3.4804 11.7396 4.10302M4.41687 10.7303C6.04656 10.2721 9.61224 9.08078 10.8375 7.98111M5.14645 13.127C6.66746 12.8984 10.236 11.5152 11.64 11.0122M9.5 17.0505C10.0137 16.4601 11.1642 14.9689 11.8305 13.5433C11.858 13.4843 11.9794 13.4861 12.0053 13.5455C12.3982 14.4495 13.6053 16.1365 14.5 17.0505M11.9722 13.9C12.0507 16.0789 12 20.7 11.1667 22.5",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.cc40a0ab50c885e9be5c709a7d6514ae.svg";
export { ForwardRef as ReactComponent };